var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "supplier-modal", attrs: { tabindex: "0" } },
    [
      _c("h3", [_vm._v("CAP Commitment Form")]),
      _vm._v(" "),
      _c("h4", [_vm._v(_vm._s(_vm.result.SupplierName))]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "terms-agree" }, [
        _c("p", [
          _vm._v(
            "By clicking below, I confirm that I have read and agree to the Terms Of Use as stated above."
          )
        ]),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.accept()
              },
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.accept()
              }
            }
          },
          [_vm._v("I Agree")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            on: {
              click: function($event) {
                return _vm.cancel()
              },
              keydown: function($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.cancel()
              }
            }
          },
          [_vm._v("Cancel")]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "terms" }, [
      _c("h5", [_vm._v("TERMS OF USE")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\tI agree to participate in the LMC Co-op Assistance Program\n\t\t\t(CAP) for the above supplier.\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\tI agree to advertise the above Supplier's products in\n\t\t\taccordance with their published Co-op Advertising Program.\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\tI understand I am to receive from LMC accrued advertising\n\t\t\tfunds as determined during the period covered by and in\n\t\t\taccordance with the Supplier's published plan.\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\tI will maintain a Proof of Performance file for 1 year for the above\n\t\t\tSupplier who may audit on my premises at their request.\n\t\t"
        )
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n\t\t\tIf I fail to use the advertising funds in accordance with the\n\t\t\tpublished plan to the satisfaction of the authorized representative\n\t\t\tof the supplier, I anticipate that I will be billed for an agreed\n\t\t\tupon amount, not to exceed the allowance received for the period,\n\t\t\tand LMC will return agreed upon amount to Supplier.\n\t\t"
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-21c74520", { render: render, staticRenderFns: staticRenderFns })
  }
}